const GIS_SRC = "https://accounts.google.com/gsi/client";

export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || "";

export const isGoogleSignInEnabled = () => !!GOOGLE_CLIENT_ID;

let loader = null;

export function loadGoogleIdentity() {
  if (window.google?.accounts?.oauth2) return Promise.resolve(window.google.accounts);
  if (loader) return loader;

  loader = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = GIS_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      if (window.google?.accounts?.oauth2) resolve(window.google.accounts);
      else reject(new Error("Google sign-in is unavailable"));
    };
    script.onerror = () => {
      loader = null;
      reject(new Error("Google sign-in is unavailable"));
    };
    document.head.appendChild(script);
  });

  return loader;
}
